// Keep in sync with portal_auth_api.PortalUserSchema
export type User = {
  id: string
  email: string
  firstName: string
  lastName: string
  isOwner: boolean
  phone: string | null
  photo: string | null
  hasPassword: boolean
  isPublicAdmin: boolean
}

const { isLoggedIn } = useAuth()
const currentUser = ref<User | undefined>()
const setUser = (user: User) => {
  currentUser.value = user
  hasLoaded.value = true
}
const clearUser = () => {
  currentUser.value = undefined
}

const hasLoaded = ref(false)
const isLoading = ref(false)
const retrieveSelf = async () => {
  if (isLoading.value) return
  isLoading.value = true
  try {
    const user = await retrieveSelfUser()
    setUser(user)
  } finally {
    isLoading.value = false
  }
}

export const useCurrentUser = () => {
  whenever(
    () => isLoggedIn.value && !hasLoaded.value,
    () => {
      retrieveSelf()
    },
    {
      immediate: true,
    }
  )

  return {
    currentUser: readonly(currentUser),
    setUser,
    clearUser,
    retrieveSelf,
  }
}
